import { ResourceType } from './resource-type';

export const REGISTRATION = new ResourceType('registration');
